<template>
  <div class="dynamic-field-container">
    <label class="radio-label">{{ field.label }}</label>
    <p-radio
      data-vv-validate-on="change"
      :name="fieldName"
      :data-vv-as="fieldName"
      v-validate="fieldValidationRules"
      v-for="kvp in field.values"
      :key="kvp.value"
      :label="kvp.label"
      :value="kvp.value"
      :disabled="isTaskFieldDisabled"
      v-model="proxyValue">
      {{ kvp.label }}
    </p-radio>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display: block; margin-top: -3px;">
      {{ getError(fieldName) }}
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    computed: {
      fieldValidationRules() {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: {},
        statusOnLoad: null
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  .radio-label {
    margin-bottom: 0;
  }
</style>
